import { FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="w-full bg-primary text-white py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
        <span className="text-sm">© {new Date().getFullYear()} SolarTools. Tüm hakları saklıdır.</span>
        <div className="flex items-center gap-8">
          <div className="flex gap-4">
            <a href="#" className="hover:text-[var(--color-highlight)] transition">Gizlilik Politikası</a>
            <a href="#" className="hover:text-[var(--color-highlight)] transition">Kullanım Şartları</a>
          </div>
          <div className="flex gap-4 text-2xl">
            <a 
              href="https://www.linkedin.com/company/solartools/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-[var(--color-highlight)] transition transform hover:scale-110"
            >
              <FaLinkedin />
            </a>
            <a 
              href="https://www.instagram.com/solar.tools" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-[var(--color-highlight)] transition transform hover:scale-110"
            >
              <FaInstagram />
            </a>
            <a 
              href="https://www.youtube.com/@SolarTools_" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-[var(--color-highlight)] transition transform hover:scale-110"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
} 